import React from "react";

import "./App.css";
import axios from "axios";
import Card from "./components/Card";
import Button from "@material-ui/core/Button";
import { styled } from "@material-ui/core/styles";


const MyButton = styled(Button)({
  background: "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)",
  border: 0,
  borderRadius: 3,
  boxShadow: "0 3px 5px 2px rgba(255, 105, 135, .3)",
  color: "white",
  width: "30%",
  height: "4.5rem",
  padding: "0 30px",
  fontSize: "1.5rem",
  marginLeft: "1rem",
});
class App extends React.Component {
  state = {
    users: [],
    error: "",
    searchUser: "",
  };
  componentDidMount() {
    this.userLoading("edelveiss");
  }

  handleChanges = (e) => {
    this.setState({
      searchUser: e.target.value,
    });
  };

  userLoading = (userString) => {
    axios
      .get(`https://api.github.com/users/${userString}`)
      .then((res) => {
        this.setState({
          users: [...this.state.users, res.data],
          followersUrl: res.data.followers_url,
          searchUser: "",
          error: "",
        });

        axios
          .get(res.data.followers_url)
          .then((response) => {
            response.data.forEach((item) => {
              axios
                .get("https://api.github.com/users/" + item.login)
                .then((response) => {
                  this.setState({
                    users: [...this.state.users, response.data],
                  });
                })
                .catch((error) => {
                  console.log("The data was not returned ", error);
                });
            });
          })
          .catch((error) => {
            console.log("The data was not returned ", error);
          });
      })
      .catch((err) => {
        this.setState({
          error:
            "Looks like we could not find that user or there are too many requests has been made. Please try again in one hour.",
        });
      });
  };

  fetchUser = (e) => {
    e.preventDefault();

    this.setState({
      users: [],
    });
    this.userLoading(this.state.searchUser);
  };

  render() {
    
    return (
      <div className="App">
        
        <div className="container">
          <div className="search-field">
        <input
          
          type="text"
          value={this.state.searchUser}
          onChange={this.handleChanges}
          placeholder="Enter GitHub user name"
        />
        <MyButton onClick={this.fetchUser}>Fetch user</MyButton>

        
        </div>
          {this.state.users.map((el, index) =>
            index === 0 ? (
              <div className="card first-user">
                <Card
                  usermap={el}
                  key={el.login}
                  keyIndex={index}
                  updateUser={this.updateUser}
                  user={el}
                />
                <div
                  style={{ fontSize: "2rem" }}
                >{`${el.login}'s followers:`}</div>
              </div>
            ) : (
              <Card
                usermap={el}
                key={el.login}
                keyIndex={index}
                updateUser={this.updateUser}
                user={el}
              />
            )
          )}
        </div>
        {this.state.error && (
          <p style={{ color: "red", fontSize: "2rem", marginTop: "2rem" }}>
            {this.state.error}
          </p>
        )}
      </div>
    );
  }
}

export default App;

